module.exports = __webpack_public_path__ + "PTMETTAcontact-2.a56ff08f.png";